/* import React from 'react';
import { Link } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import AuthorWidget from '../Widget/AuthorWidget';
import CommentsWidget from '../Widget/CommentsWidget';
import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';
const tags = [
  { tag: 'Emergency', href: '/blog/blog-details' },
  { tag: 'Pediatric', href: '/blog/blog-details' },
  { tag: 'Cardiology', href: '/blog/blog-details' },
  { tag: 'Psychiatry', href: '/blog/blog-details' },
  { tag: 'Others', href: '/blog/blog-details' },
];
const relatedBlog = [
  {
    title:
      'The Importance of Mental Health: Understanding and Managing Anxiety Disorders',
    thumbUrl: '/images/blog/post_1.jpeg',
    date: 'March 12',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    thumbUrl: '/images/blog/post_2.jpeg',
    date: 'March 11',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
  {
    title: 'Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle',
    thumbUrl: '/images/blog/post_3.jpeg',
    date: 'March 9',
    btnText: 'Learn More',
    href: '/blog/blog-details',
  },
];

export default function BlogDetails() {
  pageTitle('Blog Details');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title="The Importance of Mental Health: Understanding and Managing Anxiety Disorders" />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_tags">
              {tags.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item.tag}
                </Link>
              ))}
            </div>
            <div className="cs_blog_details_date">
              March 12, 2023 | Debri Bianca
            </div>
          </div>
          <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              <Link to="/">
                <Icon icon="fa-brands:facebook-f" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:twitter" />
              </Link>
            </div>
          </div>
        </div>
        <Spacing md="55" />
        <img
          src="/images/blog/blog_details_1.jpeg"
          alt="Blog Details"
          className="w-100 cs_radius_20"
        />
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-8">
            <div className="cs_blog_details">
              <h2>What is Anxiety Disorders</h2>
              <p>
                Anxiety disorders are a type of mental health disorder
                characterized by feelings of worry, anxiety, or fear that are
                strong enough to interfere with one's daily activities. These
                feelings may be brought on by certain situations, often relating
                to stress or trauma, but can also occur without any apparent
                reason. <br />
                <br />
                There are several types of anxiety disorders, including:
              </p>
              <ol>
                <li>
                  <b>Generalized Anxiety Disorder (GAD):</b>
                  <br />
                  This is characterized by chronic anxiety, exaggerated worry,
                  and tension, even when there is little or nothing to provoke
                  it.
                </li>
                <li>
                  <b>Panic Disorder:</b> <br />
                  This involves repeated episodes of sudden feelings of intense
                  anxiety and fear or terror that reach a peak within minutes
                  (panic attacks).
                </li>
                <li>
                  <b>Phobia-related disorders:</b>
                  <br />
                  These involve an intense fear or aversion to specific
                  situations or objects that go beyond normal boundaries and may
                  lead to avoidance behavior.
                </li>
                <li>
                  <b>Social Anxiety Disorder (Social Phobia):</b>
                  <br />
                  This is a significant amount of fear, embarrassment, or
                  humiliation in social performance-based situations, leading to
                  avoidance behavior.
                </li>
                <li>
                  <b>Obsessive-Compulsive Disorder (OCD):</b> <br />
                  This is characterized by recurrent, unwanted thoughts
                  (obsessions) and/or repetitive behaviors (compulsions).
                </li>
                <li>
                  <b>Post-Traumatic Stress Disorder (PTSD):</b> <br />
                  This can develop after exposure to a terrifying event or
                  ordeal in which severe physical harm occurred or was
                  threatened.
                </li>
              </ol>
              <p>
                Symptoms of anxiety disorders can include feelings of panic,
                fear, and uneasiness, problems sleeping, cold or sweaty hands or
                feet, shortness of breath, heart palpitations, an inability to
                be still and calm, dry mouth, numbness or tingling in the hands
                or feet, nausea, muscle tension, and dizziness. <br /> <br />
                Treatment for these disorders do exist and often involve a
                combination of psychotherapy, behavioral therapy, and
                medication. Cognitive-behavioral therapy is a particularly
                effective form of therapy that helps people learn to recognize
                and change thought patterns that lead to troublesome feelings.
                Additionally, lifestyle changes, such as dietary adjustments,
                increased physical activity, and reduction of caffeine intake,
                can also help in managing the symptoms. <br />
                <br />
                Please consult a healthcare provider for an accurate diagnosis
                and treatment if you or someone you know is experiencing
                symptoms of an anxiety disorder. This is not an exhaustive list
                of anxiety disorders or their symptoms, so professional help
                should always be sought for mental health concerns.
              </p>
              <blockquote
                style={{
                  backgroundImage: 'url("/images/blog/blog_details_2.jpeg")',
                }}
              >
                <p>
                  “Treatment for these disorders do exist and often involve a
                  combination of psychotherapy, behavioral therapy, and
                  medication.”
                </p>
              </blockquote>
              <h2>
                How to Manage Anxiety Disorders: Techniques and Strategies
              </h2>
              <p>
                Anxiety disorders can be overwhelming and interfere with daily
                life, but there are ways to manage these feelings. From
                self-care strategies to professional help, below are methods to
                effectively cope with anxiety disorders.
              </p>
              <ul>
                <li>
                  <h3>1. Professional Treatment</h3>
                  If you are dealing with an anxiety disorder, seeking
                  professional help is crucial. Mental health professionals can
                  provide a diagnosis and suggest appropriate treatment options.
                  These typically include:
                </li>
                <li>
                  <h3>2. Self-Care Techniques</h3>
                  In addition to professional treatment, there are several
                  self-care strategies that you can adopt to help manage
                  anxiety: <br />
                  <br />
                  <b>Mindful meditation and relaxation techniques:</b> Deep
                  breathing exercises, progressive muscle relaxation, and
                  mindfulness meditation can reduce symptoms of anxiety by
                  promoting relaxation and reducing feelings of fear and worry.{' '}
                  <br />
                  <br />
                  <b>Healthy lifestyle:</b> Regular physical exercise, a healthy
                  diet, adequate sleep, and reducing caffeine and alcohol can
                  also help manage anxiety symptoms. <br />
                  <br />
                  <b>Maintaining a positive outlook:</b> While it may seem
                  challenging, it's beneficial to focus on positive aspects of
                  your life. Gratitude exercises or maintaining a journal to
                  record positive experiences can assist in cultivating an
                  optimistic outlook. <br />
                  <br />
                  <b>Avoiding avoidance:</b> It's common for people with anxiety
                  to avoid situations or objects that trigger their anxiety.
                  However, avoiding these triggers can reinforce the fear. Safe
                  exposure to these triggers under the guidance of a therapist
                  can help in managing and eventually reducing anxiety.
                </li>
                <li>
                  <h3>3. Utilizing Technology</h3>
                  There are numerous digital health platforms, such as
                  smartphone apps and online counseling services, that can help
                  manage anxiety disorders. These platforms can provide
                  cognitive-behavioral therapy, mindfulness training, and other
                  helpful resources.
                </li>
              </ul>
              <h2>Conclusion</h2>
              <p>
                Anxiety disorders can be daunting, but with the right
                combination of professional help and personal coping strategies,
                they can be managed effectively. It's essential to remember that
                help is available and that you're not alone in your struggle.{' '}
                <br />
                <br />
                Remember, it's crucial to reach out to a mental health
                professional if you're experiencing symptoms of an anxiety
                disorder. What works best will depend on the individual and the
                type of anxiety disorder, and it's essential to get a
                professional's guidance for effective management.
              </p>
            </div>
            <Spacing md="85" />
            <AuthorWidget
              imgUrl="/images/blog/author.png"
              name="Author Bio"
              description="John Smith is a freelance writer and content strategist with a passion for helping businesses tell their stories. With over 10 years of experience in the industry, John has worked with a wide range of clients, from startups to Fortune 500 companies. He holds a Bachelor's degree in English from the University of California, Los Angeles (UCLA), and is an avid reader and traveler in his free time. Follow him on Twitter @johnsmithwriter for the latest updates on his work."
            />
            <Spacing md="110" />
            <CommentsWidget title="Comments" />
            <Spacing md="92" />
            <ReplyWidget title="Leave a Reply" />
          </div>
          <div className="col-lg-4">
            <Sidebar />
          </div>
        </div>
        <Spacing md="135" lg="100" />
        <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
        <Spacing md="57" />
        <div className="row cs_gap_y_40">
          {relatedBlog?.map((item, index) => (
            <div className="col-xl-4 col-md-6" key={index}>
              <Post {...item} />
            </div>
          ))}
        </div>
      </div>
      <Spacing md="200" xl="150" lg="110" />
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section>
    </>
  );
}
 */
/* 'use client';

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import AuthorWidget from '../Widget/AuthorWidget';
import CommentsWidget from '../Widget/CommentsWidget';
import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function BlogDetails() {
  const { blogId } = useParams(); // fixed: matches route param
  const [post, setPost] = useState(null);

  useEffect(() => {
    if (!blogId) {
      console.error('⛔ No blogId found in params');
      return;
    }

    const fetchPost = async () => {
      try {
        const docRef = doc(db, 'blogs', blogId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          console.log('✅ Blog Data:', data);
          setPost(data);

          const titleToUse = typeof data.title === 'string' ? data.title : 'Blog Details';
          pageTitle(titleToUse);
        } else {
          console.warn(`⚠️ No blog post found with id: ${blogId}`);
        }
      } catch (error) {
        console.error('🔥 Error fetching blog post:', error);
      }
    };

    fetchPost();
  }, [blogId]);

  const tags = post?.tags || [];
  const contentParagraphs = post?.content?.split('\n\n') || [];

  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={post?.title || 'Blog Details'} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_tags">
              {tags.map((tag, index) => (
                <Link key={index} to={`/blog?tag=${tag}`}>
                  {tag}
                </Link>
              ))}
            </div>
            <div className="cs_blog_details_date">
              {post?.publishAt || 'Date TBA'} | {post?.author || 'Unknown Author'}
            </div>
          </div>
          <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              <Link to="/"><Icon icon="fa-brands:facebook-f" /></Link>
              <Link to="/"><Icon icon="fa-brands:linkedin-in" /></Link>
              <Link to="/"><Icon icon="fa-brands:twitter" /></Link>
            </div>
          </div>
        </div>
        <Spacing md="55" />
        <img
          src={post?.image || '/images/FREEDOM.jpg'}
          alt={post?.title || 'Blog Image'}
          className="w-100 cs_radius_20"
        />
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-8">
            <div className="cs_blog_details">
              <h2>{post?.title || 'Loading...'}</h2>
              {contentParagraphs.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
            <Spacing md="85" />
            <AuthorWidget
              imgUrl="/images/blog/author.png"
              name={post?.author || 'Staff Writer'}
              description="Learn more about our team of healthcare professionals who write about important health-related topics."
            />
            <Spacing md="110" />
            <CommentsWidget title="Comments" />
            <Spacing md="92" />
            <ReplyWidget title="Leave a Reply" />
          </div>
          <div className="col-lg-4">
            <Sidebar />
          </div>
        </div>
        <Spacing md="135" lg="100" />
        <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
        <Spacing md="57" />
        <div className="row cs_gap_y_40">
          <div className="col-xl-4 col-md-6">
            <Post
              title="Preventing Heart Disease"
              thumbUrl="/images/blog/post_3.jpeg"
              date="March 9"
              btnText="Learn More"
              href="/blog/sample"
            />
          </div>
          <div className="col-xl-4 col-md-6">
            <Post
              title="Chronic Pain Management"
              thumbUrl="/images/blog/post_4.jpeg"
              date="March 8"
              btnText="Learn More"
              href="/blog/sample"
            />
          </div>
          <div className="col-xl-4 col-md-6">
            <Post
              title="Diabetes & You"
              thumbUrl="/images/blog/post_5.jpeg"
              date="March 5"
              btnText="Learn More"
              href="/blog/sample"
            />
          </div>
        </div>
      </div>
      <Spacing md="200" xl="150" lg="110" />
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section>
    </>
  );
}
 */

'use client';

import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useParams, Link, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
import Sidebar from '../Sidebar';
import AuthorWidget from '../Widget/AuthorWidget';
import CommentsWidget from '../Widget/CommentsWidget';
import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function BlogDetails() {
  const { blogId } = useParams();
  const location = useLocation();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [shareUrl, setShareUrl] = useState('');

  useEffect(() => {
    setShareUrl(window.location.origin + location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!blogId) {
      console.error('⛔ No blogId found in params');
      return;
    }

    const fetchPost = async () => {
      try {
        const docRef = doc(db, 'blogs', blogId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setPost(data);
          pageTitle(data.title || 'Blog Details');
        } else {
          console.warn(`⚠️ No blog post found with id: ${blogId}`);
        }
      } catch (error) {
        console.error('🔥 Error fetching blog post:', error);
      }
    };

    fetchPost();
  }, [blogId]);

  useEffect(() => {
    const fetchRelatedPosts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'blogs'));
        const allPosts = [];
        querySnapshot.forEach((doc) => {
          if (doc.id !== blogId) {
            allPosts.push({ id: doc.id, ...doc.data() });
          }
        });
        setRelatedPosts(allPosts.slice(0, 3)); // Show 3 related posts
      } catch (error) {
        console.error('Error fetching related posts:', error);
      }
    };

    fetchRelatedPosts();
  }, [blogId]);

  const tags = post?.tags || [];
  const contentParagraphs = post?.content?.split('\n\n') || [];
  const formattedDate = post?.publishAt
    ? new Date(post.publishAt).toLocaleDateString()
    : 'Date TBA';

  return (
    <>
      {post && (
        <HelmetProvider>
          <title>{post.title} | Freedom Prosthetics</title>
          <meta name="description" content={post.content?.slice(0, 150) || 'Read our latest blog post'} />
          <meta property="og:title" content={post.title} />
          <meta property="og:description" content={post.content?.slice(0, 150) || ''} />
          <meta property="og:image" content={post.image || '/images/FREEDOM.jpg'} />
          <meta property="og:url" content={shareUrl} />
        </HelmetProvider>
      )}

      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={post?.title || 'Blog Details'} />
      </Section>
      <div className='container'>
        <div className='cs_blog_details_info'>
          <div className='cs_blog_details_info_left'>
            <div className='cs_blog_details_tags'>
              {tags.map((tag, index) => (
                <Link key={index} to={`/blog?tag=${tag}`}>
                  {tag}
                </Link>
              ))}
            </div>
            <div className='cs_blog_details_date'>
              {formattedDate} | {post?.author || 'Staff Writer'}
            </div>
          </div>
          <div className='cs_social_links_wrap'>
            <h2>Share:</h2>
            <div className='cs_social_links'>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  shareUrl
                )}`}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Share on Facebook'
              >
                <Icon icon='fa-brands:facebook-f' />
              </a>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                  shareUrl
                )}`}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Share on LinkedIn'
              >
                <Icon icon='fa-brands:linkedin-in' />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  shareUrl
                )}&text=${encodeURIComponent(
                  post?.title || 'Check this out!'
                )}`}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Share on Twitter'
              >
                <Icon icon='fa-brands:twitter' />
              </a>
            </div>
          </div>
        </div>
        <Spacing md='55' />
        <img
          src={post?.image || '/images/FREEDOM.jpg'}
          alt={post?.title || 'Blog Image'}
          className='w-100 cs_radius_20'
        />
        <Spacing md='90' lg='50' />
        <div className='row'>
          <div className='col-lg-8'>
            <div className='cs_blog_details'>
              <h2>{post?.title || 'Loading...'}</h2>
              {contentParagraphs.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
            <Spacing md='85' />
            <AuthorWidget
              imgUrl='/images/blog/author.png'
              name={post?.author || 'Staff Writer'}
              description='Our dedicated prosthetic and orthotic specialists are committed to improving lives through innovation, compassion, and personalized care. Learn more about the people behind the insights we share.'
            />
            <Spacing md='110' />
            <CommentsWidget title='Comments' postId={blogId} />
            <Spacing md='92' />
            <ReplyWidget title='Leave a Reply' postId={blogId} />
          </div>
          <div className='col-lg-4'>
            <Sidebar />
          </div>
        </div>
        <Spacing md='135' lg='100' />
        <h2 className='mb-0 cs_fs_40 cs_medium'>Related Articles</h2>
        <Spacing md='57' />
        <div className='row cs_gap_y_40'>
          {relatedPosts.map((item) => (
            <div key={item.id} className='col-xl-4 col-md-6'>
              <Post
                title={item.title}
                thumbUrl={item.image || '/images/blog/default.jpg'}
                date={
                  item.publishAt
                    ? new Date(item.publishAt).toLocaleDateString()
                    : 'TBA'
                }
                btnText='Read More'
                href={`/blog/${item.id}`}
              />
            </div>
          ))}
        </div>
      </div>
      <Spacing md='200' xl='150' lg='110' />
      <Section className='cs_footer_margin_0'>
        <BannerSectionStyle9
          title='Don’t Let Your Health <br />Take a Backseat!'
          subTitle='Schedule an appointment with one of our experienced <br />medical professionals today!'
          imgUrl='/images/doctors/banner_img_3.png'
        />
      </Section>
    </>
  );
}
